import Papa from 'papaparse';

function trimStr(str: string): string {
  return str.trim();
}

const CSVHelper = {
  parse(file: File): Promise<Papa.ParseResult> {
    return new Promise((complete: (result: Papa.ParseResult) => void) => {
      Papa.parse(file, {
        header: true,
        transformHeader: trimStr, // Applies this function to each header
        delimiter: ',',
        skipEmptyLines: 'greedy',
        complete,
      });
    });
  },
};

export default CSVHelper;
